<div class="modal-content">
  <div class="modal-body text-center modal-erro-ao-acessar-camera__body">
    <section class="modal-erro-ao-acessar-camera__content">
      <img src="../../../../../assets/images/warn_no_webcam.svg" alt="videocam">
    </section>
    <div class="modal-erro-ao-acessar-camera__title">Oops... Não conseguimos identificar uma câmera!</div>
    <div class="modal-erro-ao-acessar-camera__subtitle">Não conseguimos iniciar a sua câmera. Para continuar é necessário verificar e permitir que o navegador acesse a sua webcam.</div>
    <div class="modal-erro-ao-acessar-camera__subtitle">Verifique também se nenhum outro site ou aplicativo está utilizando a câmera.</div>
  </div>
  <div class="modal-footer modal-erro-ao-acessar-camera__action">
    <app-gradient-button
      label="OK, ENTENDI"
      (click)="close()">
    </app-gradient-button>
  </div>
</div>
